"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CLink = _interopRequireDefault(require("01_core/components/materials/CLink"));
var _CodeConsts = require("01_core/constants/CodeConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 発見事項分類列
 */
const CountTable = (0, _styles.styled)(_Table.default)({
  height: '100% !important',
  width: '100%',
  tableLayout: 'fixed',
  borderCollapse: 'collapse'
});
const JigyocellWidthCell = (0, _styles.styled)(_TableCell.default)({
  width: '40%'
});
const CellWidthCell = (0, _styles.styled)(_TableCell.default)({
  paddingRight: 8,
  width: '15%'
});
const BorderLeftBodyCell = (0, _styles.styled)(CellWidthCell)(_ref => {
  let {
    theme
  } = _ref;
  return {
    borderLeft: 'solid 1px',
    borderLeftColor: theme.palette.border && theme.palette.border.gray
  };
});
const CountsColumn = props => {
  const {
    intl,
    onLinkClick,
    item,
    totalRow
  } = props;
  const countCell = (counts, item, hakkenjikoBunruiCd, CellComp) => {
    if (totalRow || item.kansaCompFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
      return /*#__PURE__*/_react.default.createElement(CellComp, {
        align: "right"
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "body2"
      }, counts > 0 ? /*#__PURE__*/_react.default.createElement(_CLink.default, {
        onClick: onLinkClick(item, hakkenjikoBunruiCd)
      }, intl.formatNumber(counts)) : counts));
    } else {
      return /*#__PURE__*/_react.default.createElement(CellComp, {
        align: "right"
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "body2"
      }, _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU));
    }
  };
  return /*#__PURE__*/_react.default.createElement(CountTable, null, /*#__PURE__*/_react.default.createElement("colgroup", null, /*#__PURE__*/_react.default.createElement("col", {
    style: {
      width: '40%'
    }
  }), /*#__PURE__*/_react.default.createElement("col", {
    style: {
      width: '15%'
    }
  }), /*#__PURE__*/_react.default.createElement("col", {
    style: {
      width: '15%'
    }
  }), /*#__PURE__*/_react.default.createElement("col", {
    style: {
      width: '15%'
    }
  }), /*#__PURE__*/_react.default.createElement("col", {
    style: {
      width: '15%'
    }
  })), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(JigyocellWidthCell, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(item.kansaTgtJigyoNm))), countCell(item.judaiCounts, item, _CodeConsts.CODE.KANSA_HKN_BNR.CODE_1, BorderLeftBodyCell), countCell(item.keibiCounts, item, _CodeConsts.CODE.KANSA_HKN_BNR.CODE_2, CellWidthCell), countCell(item.kansatsuCounts, item, _CodeConsts.CODE.KANSA_HKN_BNR.CODE_3, BorderLeftBodyCell), countCell(item.suishoCounts, item, _CodeConsts.CODE.KANSA_HKN_BNR.CODE_4, CellWidthCell))));
};
var _default = exports.default = (0, _reactIntl.injectIntl)(CountsColumn);